module.exports = __webpack_public_path__ + "f3605459729f2b5ece4b15f887f67dbc.svg";